export class CommonConfig {
    enableUseCaseStatusLogs? = false;
}